const _none = "none"
const config = { "none": _none, "card-hover": "0px 0px 20px rgba(0, 0, 0, 0.1)", "contextual-subnavigation": "0px 4px 4px rgba(0, 0, 0, 0.25)",  }
export { config as default, _none }